var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"button has-text-success whatsapp has-text-weight-semibold",attrs:{"tag":"a","title":_vm.title,"icon-left":"whatsapp","icon-pack":"fab","size":"is-medium"},on:{"click":_vm.prompt}},[_vm._v(" "+_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }